import { HEADER } from "./_consts";
import { HAMBURGER } from "./_consts";

import { openFullScreenOverlay, closeFullScreenOverlay } from "./_fullScreenOverlayControl";
import { focusToButton, modalFocus } from "./_modalFocus";
import { scrollLock, scrollLockFix, scrollLockFixRemove } from "./_scrollLock";

/**
 * ドロワーメニューの開閉状態によって処理を分ける
 * ドロワーメニューが閉じていれば開くし開いていれば閉じる
 */
export function drawerDisplayControl() {
  if (isDrawerOpen()) {
    closeDrawerMenu();
    // closeFullScreenOverlay();
  } else {
    openDrawerMenu();
    // openFullScreenOverlay();
  }
}

/**
 * ドロワーメニューの開閉
 * modalControl.jsを使用
 * buttonクリックでドロワーメニューの開閉を切り替える
 * ドロワーメニューが開いている時はbodyをスクロールさせない
 */
const nav = document.getElementById('js_globalNav');
const navLink = nav?.querySelectorAll('a');

/**
 * ⭐キーボードフォーカスのイベントハンドラ
 */
function focusHandleMenu(event) {
  modalFocus(event, nav, close);
}

/**
 * open drawer menu
 */
function openDrawerMenu() {
  // モーダル表示状態のクラスを追加する
  HAMBURGER.classList.add('is_open');
  nav.classList.add('is_open');

  // ⭐キーボードフォーカスの制御イベントを登録
  window.addEventListener('keydown', focusHandleMenu, { capture: true });

  // ⭐スクロール固定のイベントを登録
  document.addEventListener('touchmove', scrollLock, { passive: false });
  scrollLockFix(nav);

  // ⭐フォーカス可能な先頭の要素にフォーカス
  focusToButton(nav);
}

/**
 * close drawer menu
 */
const closeDrawerMenu = () => {
  // モーダル表示状態のクラスを削除する
  HAMBURGER.classList.remove('is_open');
  nav.classList.remove('is_open');

  // ⭐キーボードフォーカスの制御を破棄
  window.removeEventListener('keydown', focusHandleMenu, { capture: true });

  // ⭐スクロール固定のイベントを破棄
  document.removeEventListener('touchmove', scrollLock);
  scrollLockFixRemove(nav);

  // ⭐フォーカス位置を戻す
  HAMBURGER.focus();
}

/**
 * ドロワーメニューが開いているか判定
 * @returns {Boolean} ドロワーメニューが開いていればtrue
 */
const isDrawerOpen = () => {
  return nav.classList.contains('is_open');
}

// ドロワーメニュー内の<a>にクリックイベントを登録
// ドロワーメニューオープン時にドロワーメニュー内の<a>がクリックされたらドロワーメニューを閉じる
// アンカーリンクがある場合は有効にする
if (navLink) {
  navLink.forEach((element) => {
    element.addEventListener('click', () => {
      if (isDrawerOpen()) {
        closeDrawerMenu();
        // closeFullScreenOverlay();
      }
    })
  });
}